module.exports = __webpack_public_path__ + "static/media/ulip.0c7d8a3a.mp3";